module.exports = __webpack_public_path__ + "img/add_annoucment.93cc83c2.svg";